import { isCustom } from '@/models/defectType';
import { ArticleDefectWithRelations } from '@/models/request';
import { areSimilar } from '@/utils/array';

export const getEditedFields = ({
  defect,
  previousDefect,
}: {
  defect?: ArticleDefectWithRelations;
  previousDefect?: ArticleDefectWithRelations;
}) => {
  if (!previousDefect || !defect) {
    return {
      isNameEdited: false,
      isContextEdited: false,
      isPhotosEdited: false,
      isToBeRepairedEdited: false,
      isBrandResponsibilityEdited: false,
      isExceptionalBrandResponsibilityCoverageRequestedEdited: false,
      isExceptionalBrandResponsibilityCoverageReasonEdited: false,
    };
  }

  return {
    isNameEdited:
      isCustom(defect) &&
      isCustom(previousDefect) &&
      defect.customDescription !== previousDefect.customDescription,
    isContextEdited: defect.context !== previousDefect.context,
    isPhotosEdited: !areSimilar(defect.media, previousDefect.media, 'id'),
    isToBeRepairedEdited: defect.toBeRepaired !== previousDefect.toBeRepaired,
    isBrandResponsibilityEdited: defect.brandResponsibility !== previousDefect.brandResponsibility,
    isExceptionalBrandResponsibilityCoverageRequestedEdited:
      defect.exceptionalBrandResponsibilityCoverageRequested !==
      previousDefect.exceptionalBrandResponsibilityCoverageRequested,
    isExceptionalBrandResponsibilityCoverageReasonEdited:
      defect.exceptionalBrandResponsibilityCoverageReason !==
      previousDefect.exceptionalBrandResponsibilityCoverageReason,
  };
};
